export const PRIMARY_FONT = "Lato"



// WEBPACK FOOTER //
// ./src/theme/typography.js